import generateStore from './generateStore.js'
import { axios } from '../request'

export default (app) => {
  const apiURL = app.config.globalProperties.$apiURL
  const url = 'membership_card_letters'
  const store = generateStore('membershipCardLetters', app)

  store.actions.get = (context, id) => {
    return new Promise((resolve) => {
      axios.get(url + '/' + id).then((res) => {
        window.location.replace(apiURL + '/' + res.data.data.url)
        resolve()
      })
    })
  }
  return store
}
